<template>
  <div class="team-item">
    <a class="team-item-header d-flex align-items-center" @click="click">
      <div class="team-item-avatar">
        <avatar variant="teambig" :src="team.photo" rounded="lg" size="3.125rem" font-size="2rem" />
      </div>
      <div class="team-item-title ml-3">
        {{ team.name }}
      </div>
    </a>
    <b-collapse ref="members" :visible="!isAllMembers">
      <div v-if="!isAllMembers" class="d-flex mt-3">
        <div class="member-qm-line" />
        <div class="member-qm">
          <b-link @click="$emit('team-give-kudo', team)"><kudos-icon /> Give kudo</b-link>
          <b-link @click="$emit('team-send-message', team)"><chat-icon /> Send message</b-link>
          <b-link :to="{name: 'Team', params: { teamId: team.id }}"><team-avatar-icon /> View Profile</b-link>
          <b-link v-if="canInviteUsers" @click="$emit('invite-users', team)">
            <b-icon-person-plus-fill /> Send an invitation
          </b-link>
        </div>
      </div>
      <team-member-list
        :me-profile="meProfile"
        :members="members"
        @give-kudo="$emit('member-give-kudo', $event)"
        @send-message="$emit('member-send-message', $event)"
      />
    </b-collapse>
  </div>
</template>

<script>
import { BIconPersonPlusFill } from 'bootstrap-vue'
import Avatar from '@/components/common/Avatar'
import TeamMemberList from './TeamMemberList.vue'
import KudosIcon from '@/assets/images/kudos.svg'
import TeamAvatarIcon from '@/assets/images/team-avatar.svg'
import ChatIcon from '@/assets/images/chat.svg'
import { ALL_MEMBERS_ID } from '@/helpers/constants'

export default {
  name: 'TeamItem',

  props: {
    team: {
      type: Object,
      required: true
    },

    profiles: {
      type: Object,
      default: () => ({})
    },

    meProfile: {
      type: Number
    },

    isAdmin: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    members() {
      return this.team.members.reduce((out, value) => {
        const { member, profile, ...other } = value
        out.push({ ...other, ...this.profiles[profile] })
        return out
      }, [])
    },

    canInviteUsers() {
      const me = this.members.find(p => p.id === this.meProfile)
      return this.isAdmin || (me ? me.isManager : false)
    },

    isAllMembers() {
      return this.team.id === ALL_MEMBERS_ID
    }
  },

  methods: {
    click() {
      this.$refs.members.toggle()
    }
  },

  components: {
    BIconPersonPlusFill,
    TeamMemberList,
    KudosIcon,
    TeamAvatarIcon,
    ChatIcon,
    Avatar
  }
}
</script>
